jQuery(document).ready(function () {

    jQuery('#site-header span.background').click(function () {
        let siteHeader = document.querySelector('#site-header');
        let body = document.querySelector('body');
        let openButton = siteHeader.querySelector('#hamburger-menu-button .open');

        body.classList.remove('is-menu-on');
        siteHeader.classList.remove('is-menu-on');
        openButton.setAttribute('aria-expanded', 'false');
    });

    jQuery('#site-header span.icon-clear').click(function () {
        let siteHeader = document.querySelector('#site-header');
        let body = document.querySelector('body');
        let openButton = siteHeader.querySelector('#hamburger-menu-button .open');

        body.classList.remove('is-menu-on');
        siteHeader.classList.remove('is-menu-on');
        openButton.setAttribute('aria-expanded', 'false');
    });
});

